import AlertModal from '@/components/modal/AlertModal';
import { createContext, ReactNode, useContext, useState } from 'react';

interface AlertTypeProps {
  message: string;
  onConfirm?: () => void;
  buttonText?: string;
}
interface AlertContextType {
  showAlert: ({ message, onConfirm, buttonText }: AlertTypeProps) => void;
}

const AlertContext = createContext<AlertContextType | undefined>(undefined);

export const AlertProvider = ({ children }: { children: ReactNode }) => {
  const [message, setMessage] = useState<string>('');
  const [onConfirm, setOnConfirm] = useState<() => void>(() => {});
  const [visible, setVisible] = useState<boolean>(false);
  const [buttonText, setButtonText] = useState<string | null>(null);

  const showAlert = ({ message, onConfirm, buttonText }: AlertTypeProps) => {
    setMessage(message);
    setOnConfirm(() => onConfirm || (() => {}));
    setVisible(true);
    if (buttonText) {
      setButtonText(buttonText);
    }
  };

  const handleClose = () => {
    setVisible(false);
    onConfirm();
    // 상태 초기화
    setMessage('');
    setButtonText('');
    setOnConfirm(() => () => {});
  };

  return (
    <AlertContext.Provider value={{ showAlert }}>
      {children}
      {visible && (
        <AlertModal
          message={message}
          onClose={handleClose}
          buttonText={buttonText ? buttonText : '확인'}
        />
      )}
    </AlertContext.Provider>
  );
};

export const useAlert = () => {
  const context = useContext(AlertContext);
  if (!context)
    throw new Error('useAlert must be used within an AlertProvider');
  return context;
};
